import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { messages } from "vee-validate/dist/locale/es.json";

const moneyValidator = {
  validate(value, args) {
    if (value == "" || value === undefined) return false;
    const parsedValue = value
      .split("")
      .filter(c => c <= "9" && c >= "0")
      .join("");

    const firstValidation =
      parsedValue !== undefined &&
      parsedValue.length > 0 &&
      Number(parsedValue);

    const secondValidation =
      !args.min || Number(parsedValue) >= Number(args.min);

    const thirdValidation =
      !args.max || Number(parsedValue) <= Number(args.max);

    return firstValidation && secondValidation && thirdValidation;
  },
  message: (field, { min, max }) => {
    let out = `El campo ${field} no es válido, `;
    if (min !== undefined)
      out += `debe ser de al menos $${min}${max ? " y " : "."}`;
    if (max !== undefined) out += `no debe ser superior a $${max}.`;

    return out;
  },
  params: ["min", "max"]
};

const phoneValidator = {
  validate(value, args) {
    if (value == "" || value === undefined) return false;
    const parsedValue = value
      .split("")
      .filter(c => c <= "9" && c >= "0")
      .join("");

    const firstValidation =
      parsedValue !== undefined &&
      parsedValue.length > 0 &&
      Number(parsedValue) &&
      Number(parsedValue) > 0;

    const secondValidation =
      !args.length || parsedValue.length == Number(args.length);

    return firstValidation && secondValidation;
  },
  message: (field, { length }) => {
    let out = `El campo ${field} no es válido, `;
    if (length !== undefined) out += `debe ser de ${length} dígitos.`;
    return out;
  },
  params: ["length"]
};

export default {
  install(Vue) {
    Vue.component("validation-provider", ValidationProvider);
    Vue.component("validation-observer", ValidationObserver);

    Object.keys(rules).forEach(rule => {
      extend(rule, { ...rules[rule], message: messages[rule] });
    });

    extend("money", moneyValidator);
    extend("phone", phoneValidator);

    // with typescript
    for (let [rule, validation] of Object.entries(rules)) {
      extend(rule, {
        ...validation
      });
    }
  }
};
